import { ORDERS_SECTION_PERMISSIONS } from 'components/practice/charts/Orders/lib/tabs';
import { HEALTH_RECORDS_PERMISSIONS } from 'components/practice/charts/HealthRecords/lib/tabsData';

const PATIENT_CHART_SIDEBAR_ITEMS = [
  { path: '', label: 'Overview', icon: 'health-mono', end: true },
  {
    path: 'profile',
    label: 'Profile',
    icon: 'note-text-1-mono',
    permission: 'patients.read'
  },
  {
    path: 'health-records',
    label: 'Health records',
    icon: 'patient-history-mono',
    permission: HEALTH_RECORDS_PERMISSIONS,
    permissionLogic: 'or'
  },
  {
    path: 'clinical-notes',
    label: 'Clinical notes',
    icon: 'note-mono',
    permission: 'clinical_note.read'
  },
  {
    path: 'orders',
    label: 'Orders',
    icon: 'prescribe-mono',
    permission: ORDERS_SECTION_PERMISSIONS,
    permissionLogic: 'or'
  },
  {
    path: 'appointments',
    label: 'Appointments',
    icon: 'calendar-2-mono',
    permission: 'appointments.read'
  },
  {
    path: 'billing',
    label: 'Billing',
    icon: 'bill-mono',
    permission: 'billing.read'
  },
  { path: 'payments', label: 'Invoices & payments', icon: 'wallet-mono' },
  {
    path: 'communications',
    label: 'Communications',
    icon: 'messages-mono',
    permission: 'patient_communication.read'
  },
  {
    path: 'documents',
    label: 'Documents',
    icon: 'document-text-mono',
    permission: 'patient_documents_center.read'
  }
];

export default PATIENT_CHART_SIDEBAR_ITEMS;
